export default {"src":"/_next/static/media/gastro_experience.3f8aa5ee.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};